export enum Route {
  Home = '/',
  Login = '/login',

  Dashboard = '/dashboard',
  ServiceProviderDetail = '/dashboard/:serviceProviderId',
  OrganizationList = '/dashboard/:serviceProviderId',
  OrganizationDetail = '/dashboard/:serviceProviderId/:organizationId',
  OrganizationPortfolioList = '/dashboard/:serviceProviderId/:organizationId/portfolios',
  OrganizationPortfolioDetail = '/dashboard/:serviceProviderId/:organizationId/portfolios/:portfolioId',
  OrganizationPortfolioRankingsList = '/dashboard/:serviceProviderId/:organizationId/portfolios/:portfolioId/rankings',
  OrganizationPortfolioBuildingsList = '/dashboard/:serviceProviderId/:organizationId/portfolios/:portfolioId/buildings',

  PortfolioList = '/dashboard/:serviceProviderId/portfolios',
}
